import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSubtract = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 69,
	height: 66,
	viewBox: "0 0 69 66",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.344296 61.1268L31.3953 1.6123C32.5169 -0.537431 35.5932 -0.537437 36.7148 1.6123L67.7658 61.1267C68.8079 63.124 67.3589 65.5144 65.1061 65.5144H3.00405C0.751254 65.5144 -0.697773 63.124 0.344296 61.1268ZM31.0551 47.5144V53.5144H37.0551V47.5144H31.0551ZM37.0551 26.5144H31.0551V44.5144H37.0551V26.5144Z",
		fill: "#F1C962"
	})
});
export default SvgSubtract;
